module.exports = __webpack_public_path__ + "img/title-pink.e4b381f4.png";